export default {
  list: { lazy: () => import('./RoofTypes'), component: 'RoofTypeList' },
  edit: { lazy: () => import('./RoofTypes'), component: 'RoofTypeEdit' },
  create: { lazy: () => import('./RoofTypes'), component: 'RoofTypeCreate' },
}
